import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ErrorStyles.css";

const NotFound = ({ id }) => {
    useEffect(() => {
        document.title = "EP Not Found";
    }, []);

    return (
        <>
            <Grid container className="container">
                <div className="errorContainer">
                    <h1 className="errorTitle">404</h1>
                    <p className="errorContent">
                        EP {id} does not exist.
                    </p>
                    <a href="/" className="errorButton">
                        BACK TO HOME
                    </a>
                </div>
            </Grid>
            <a className="copyText" href="https://immunetolerance.org">
                &#169; <img className="copyLogo" src="itn-logo-small.png"  alt="ITN logo"/> Immune
                Tolerance Network
            </a>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Slide}
            />
        </>
    );
}

export default NotFound;